import { useEffect, useState } from "react";
import { FetchApi } from "../../api/fetch";
import { GO_DE_GQL_BACKEND_URL } from "../../constants";
import { Collection } from "../../types";
import { ActionDialog } from "../ActionDialog";
import Button from "../Button";
import { DeLoading } from "../DeLoading";
import { useBlockchain } from "../../contexts/blockchain";
import { Blockchain } from "../../pages/private/ManageDraft/types";

interface MintHashPreviewProps {
  collection: Collection;
  id: string
}

export const MintHashPreview = ({ collection, id }: MintHashPreviewProps) => {
  const { currentBlockchain }:any = useBlockchain() 
  const [isFullMintListDisplayed, setIsFullMintListDisplayed] = useState(false);
  const [isLoading, setisLoading] = useState(true)
  const [mintList, setMintList] = useState<{ mints: string, collectionId: string }[]>()

  useEffect(() => {
    if (currentBlockchain != Blockchain.Bitcoin) {
      getMintList();
    } else {
      getInsciptions() 
    }
  }, [])


  const getMintList = async () => {
    try {
      let mints: any = [];
      const res = await FetchApi({
        endpoint: `${GO_DE_GQL_BACKEND_URL}`,
        method: "POST",
        body: {
          query: `
          query MintItems {
            items(collectionId: "${id}") {
              nodes {
                mints
                collectionId
              }
            }
          }
          `
        }
      })
      await res?.data?.items?.nodes.forEach((elem: any) => {
        mints = [...mints, ...elem.mints]
      })
      setMintList(mints)

    } catch (err) {
      console.log(err)
    }

    setisLoading(false)
  }

  const getInsciptions = async () => {
    try {
      let mints: any = [];
      const res = await FetchApi({
        endpoint: `${GO_DE_GQL_BACKEND_URL}`,
        method: "POST",
        body: {
          query: `
          query Inscription {
            ordinalsItems(collectionId: "${id}") {
              nodes {
                collectionId
                mints
              }
            }
          }
          `
        }
      })
      await res?.data?.ordinalsItems?.nodes.forEach((elem: any) => {
        mints = [...mints, ...elem.mints]
      })
      setMintList(mints)

    } catch (err) {
      console.log(err)
    }

    setisLoading(false)
  }
  return (
    <>
      <ActionDialog
        isOpen={isFullMintListDisplayed}
        onCloseClick={() => setIsFullMintListDisplayed(false)}
        heading="Mint List"
      >
        <p className="overflow-scroll max-h-96 text-center">{`${mintList?.map(
          (hash) => ` ${hash}`
        )}`}</p>
      </ActionDialog>
      {mintList && mintList.length > 0 && !isLoading && (
        <Button
          type="button"
          disabled={isLoading || mintList.length < 1}
          className="m-3 btn border-gradient"
          onClick={() => setIsFullMintListDisplayed(true)}
        >
          {`Show All ${mintList?.length} mint hashes`}
        </Button>
      )}
      {isLoading && (
        <div
          className="text-center"
        >
          <DeLoading />
          <span>{"Loading mint hash list..."}</span>
        </div>
      )}

      {
        mintList && mintList?.length > 0 &&
        <a
          type="button"
          href={`data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(mintList))}`}
          download={`${collection?.name} mints list.json`}
          className="btn m-3 border-gradient"
        >
          {`Download Mint List (.JSON)`}
        </a>
      }
    </>

  );
};
